export function initStickyHeader() {
  const header = document.querySelector('.site-header-menu');
  if (!header) return;

  // Sentinel invisible
  const sentinel = document.createElement('div');
  sentinel.style.position = 'absolute';
  sentinel.style.top = '90px';
  sentinel.style.width = '1px';
  sentinel.style.height = '1px';
  sentinel.style.pointerEvents = 'none';

  document.body.prepend(sentinel);

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.classList.toggle('sticky-header', !entry.isIntersecting);
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(sentinel);
}